import { render, staticRenderFns } from "./ManageTestmonial.vue?vue&type=template&id=6f5ab0b7"
import script from "./ManageTestmonial.vue?vue&type=script&lang=js"
export * from "./ManageTestmonial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports